import { render } from "./AddArticle.vue?vue&type=template&id=1a9d9034&scoped=true&ts=true"
import script from "./AddArticle.vue?vue&type=script&lang=ts"
export * from "./AddArticle.vue?vue&type=script&lang=ts"

import "./AddArticle.vue?vue&type=style&index=0&id=1a9d9034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9d9034"]])

export default __exports__